import React from 'react';

function BackIcon(props) {
    return (
        <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.75 7.72571L0.75 7.72571" stroke="#11141F" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M9.7002 1.70131L15.7502 7.72531L9.7002 13.7503" stroke="#11141F" strokeWidth="1.5"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
}

export default BackIcon;
